/* eslint-disable react/jsx-no-undef */
import * as React from 'react'
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';

import { AboutUsContent, BaseDiv, DoubleInput, TextBody, TextContent } from './styles';
import Input from '../../../../Input';
import Button from '../../../../Button';
import FormService from '../../../../../services/form';
import { useToast } from '../../../../../hooks/toast';

interface INavBar {
    
}

const Formulario: React.FC<INavBar> = () => {

    const formRef = React.useRef<FormHandles>(null);
    const servicesForm = { FormService: new FormService() };
    const { addToast } = useToast();

    const handleSubmit = React.useCallback(
        async (data: any) => {
          try {
            formRef.current?.setErrors({});
      
            console.log(data);
            // const response = await servicesForm.FormService.postContato({
            //   name: data.name,
            //   email: data.email,
            //   phone: data.phone,
            //   name_company: data.name_company,
            // });
            addToast({
              type: 'success',
              title: 'Formulario enviado',
              description: 'Formulario enviado com sucesso',
            });
          } catch (err: any) {
            const { ...error } = err;

            console.log(error);
           
            addToast({
                type: 'error',
                title: 'Erro ao enviar o formulario',
                description:'Verifique se todos os campos preenchidos estão preenchidos corretamente.',
            });
            
          }
        },
        [addToast, useToast],
      );

    return (
        <BaseDiv>
            <AboutUsContent>
                <TextContent>
                    <TextBody>
                        <Form ref={formRef} onSubmit={handleSubmit} placeholder={undefined}>
                            <Input name='name' label='NOME'/>
                            <Input name='email' label='E-MAIL'/>
                            <DoubleInput>
                                <Input name='phone' label='TELEFONE' />
                                <Input name='name_company' label='EMPRESA'/>
                            </DoubleInput>
                            <Button color='orange' padding={'10px'}type="submit">
                                ENVIAR
                            </Button>
                        </Form>
                    </TextBody>
                </TextContent>
            </AboutUsContent>
        </BaseDiv>
    );
}

export { Formulario }